import MuiButton from "@mui/material/Button";
import styled, { keyframes } from "styled-components";

import type { ButtonAppearance, ButtonSize } from "./variants";
import { BUTTON_APPEARANCE_STYLES, BUTTON_SIZE_STYLES } from "./variants";

type ButtonCustomStyleProps = {
  $color?: string;
  $backgroundColor?: string;
  $padding?: string;
  $width?: string;
  $border?: string;
  $borderRadius?: string;
  $fontSize?: string;
  $minWidth?: string;
  $height?: string;
  $alignSelf?: string;
  $disabledBackgroundColor?: string;
  $disabledOpacity?: number;
  disabled?: boolean;
};

export const ButtonCustom = styled(MuiButton)<ButtonCustomStyleProps>`
  box-shadow: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-family: "Noto Sans" !important;
  font-size: ${({ $fontSize }) => ($fontSize ? `${$fontSize} !important` : "14px !important")};
  font-weight: 600 !important;
  text-transform: none !important;
  color: ${({ $color }) => ($color ? `${$color} !important` : "inherit")};
  background-color: ${({ $backgroundColor, $disabledBackgroundColor, disabled }) =>
    disabled
      ? `${$disabledBackgroundColor ?? "gray"} !important`
      : $backgroundColor
        ? `${$backgroundColor} !important`
        : "transparent"};
  opacity: ${({ disabled, $disabledOpacity }) =>
    disabled && $disabledOpacity != null ? $disabledOpacity : 1};
  padding: ${({ $padding }) => ($padding ? `${$padding} !important` : "8px 16px")};
  width: ${({ $width }) => ($width ? `${$width} !important` : "auto")};
  border: ${({ $border }) => ($border ? `${$border} !important` : "none")};
  border-radius: ${({ $borderRadius }) =>
    $borderRadius ? `${$borderRadius} !important` : "0"};
  ${({ disabled }) => disabled && "pointer-events: none"};
  ${({ $height }) => $height && `height: ${$height};`}
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth} !important;`}
  align-self: ${({ $alignSelf }) => $alignSelf};
`;

export const VariantButton = styled.button<{
  $appearance: ButtonAppearance;
  $size: ButtonSize;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: none;
  font-family: "Noto Sans", sans-serif;
  text-transform: none;
  cursor: pointer;
  width: fit-content;

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  ${({ $appearance }) => BUTTON_APPEARANCE_STYLES[$appearance]}
  ${({ $appearance, $size }) => BUTTON_SIZE_STYLES[$appearance][$size] ?? ""}
`;

export const IconSlot = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${spin} 700ms linear infinite;
  flex-shrink: 0;
`;
